import { sqliteTable, text, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// period_locks — Month-level lock (#281)
// ล็อกเดือนที่ปิดงบแล้ว เพื่อไม่ให้ submit/cancel รายการย้อนหลังไปกระทบตัวเลข
// ภ.พ.30 ที่ยื่นไปแล้ว. Layer ถัดจาก fiscal_years.isClosed ที่ล็อกระดับปี.
// ============================================================================
export const periodLocks = sqliteTable(
  "accounting_period_locks",
  {
    id: text("id").primaryKey(), // ULID
    companyId: text("company_id").notNull(),
    // YYYY-MM (e.g. "2026-03"). Derived from any date that falls inside the
    // locked month; the service normalises via date.slice(0, 7).
    periodMonth: text("period_month").notNull(),
    lockedAt: text("locked_at").notNull(),
    lockedBy: text("locked_by").notNull(),
    reason: text("reason"),
    // Soft-delete so a genuine mis-lock can be reversed without losing the
    // audit trail of the original lock. Active lock check filters isNull.
    deletedAt: text("deleted_at"),
    deletedBy: text("deleted_by"),
  },
  (table) => ({
    companyMonthIdx: index("period_lock_company_month_idx").on(
      table.companyId,
      table.periodMonth,
    ),
  }),
);

export type PeriodLock = typeof periodLocks.$inferSelect;
export type NewPeriodLock = typeof periodLocks.$inferInsert;
